// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + chunkId + "-" + {"167":"610e7ed9f6a6db62a3e2","325":"7f9d8c05cebb989cf060","636":"67f561bce658c484cca0"}[chunkId] + ".js";
};